// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"ae472084","231":"8710b8af","483":"17cf87af","539":"de1dc445","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};